import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { adminPaths } from '../../constants/paths';

import styles from './AdministrationTabs.module.scss';

const administrationTabDefinitions = [
  {
    getPath: adminPaths.companyInfo,
    title: 'Информация по компании',
  },
  {
    getPath: adminPaths.workSchedule,
    title: 'График работы',
    requiredPermissions: ['AllowWorkSchedule'],
  },
];

const hasRequiredPermissions = (userInfo = {}, requiredPermissions = []) =>
  requiredPermissions.every((permission) => Boolean(userInfo?.[permission]));

export const getAvailableAdministrationTabs = ({ companyId, userInfo }) =>
  administrationTabDefinitions
    .filter((tab) => hasRequiredPermissions(userInfo, tab.requiredPermissions))
    .map(({ getPath, title }) => ({
      to: getPath(companyId),
      title,
    }));

export const AdministrationTabs = ({ companyId }) => {
  const { userInfo } = useSelector((state) => state.authentication);
  const administrationRoutes = useMemo(
    () => getAvailableAdministrationTabs({ companyId, userInfo }),
    [companyId, userInfo]
  );

  return (
    <ul className={styles.list}>
      {administrationRoutes.map((route) => (
        <li key={route.to}>
          <NavLink
            to={route.to}
            className={cn('ant-btn', styles.list__link)}
            activeClassName="ant-btn-primary"
          >
            {route.title}
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

AdministrationTabs.propTypes = {
  companyId: PropTypes.number.isRequired,
};
